import { gql } from "graphql-request";

export const GET_MANUFACTURER_SUBMISSION = gql`
query GetManufacturerSubmission(
  $clientId: String
  $tenantId: String
  $manufacturerId: String
) {
  getManufacturerSubmission(
    clientId: $clientId
    tenantId: $tenantId
    manufacturerId: $manufacturerId
  ) {
    data {
      _id
      clientId
      tenantId
      manufacturerId
      manufacturerEmail
      supplierResponse {
        step1 {
          sentDate
        }
        step2 {
          responses {
            heading
            description
            sentDate
            response
          }
          responseDate
        }
        step3 {
          validationDate
          reportStatus
          reportUrl
        }
        step4 {
          engagementDate
        }
      }
      status
    }
  }
}
`
